import { Box, ButtonSize, Checkbox, Heading, SideSheetClose, SideSheetHeader, Text } from '@bechtel/gds';
import { map, sortBy } from 'lodash';
import { FC, useRef } from 'react';
import { MultiLingualText, useAppUser, useLanguage, useLanguageUpdater } from '~/components';
import { useOutsideClick } from '~/hooks';
import { DrawerBackdropStyled, DrawerOuterStyled, SideSheetBodyStyled, SideSheetCloseContainer } from './styled';

interface MyAccountProps {
  close: () => void;
}
const MyAccount: FC<MyAccountProps> = ({ close }) => {
  const { userAccount } = useAppUser();
  const { isAlternateLanguageUsed } = useLanguage();
  const { alternateLanguageUsed } = useLanguageUpdater();

  const handleChange = () => {
    alternateLanguageUsed(!isAlternateLanguageUsed);
  };

  const ref = useRef();
  useOutsideClick(ref, () => {
    close();
  });

  return (
    <DrawerBackdropStyled onClick={close} ref={ref}>
      <DrawerOuterStyled
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <SideSheetHeader title="My Account">
          <SideSheetCloseContainer>
            <SideSheetClose onClick={close} size={ButtonSize.SMALL}></SideSheetClose>
          </SideSheetCloseContainer>
        </SideSheetHeader>

        <SideSheetBodyStyled>
          <Box m={{ sm: '400' }}>
            <Heading size="600">
              {userAccount?.nameFirst} {userAccount?.nameLast}
            </Heading>
          </Box>
          {userAccount?.defaultProject?.alternateLanguageCode && (
            <Box m={{ sm: '400' }} flexGrow={{ sm: '1' }}>
              <MultiLingualText>Use alternate language</MultiLingualText>
              <Text>{` (${userAccount?.defaultProject?.alternateLanguageCode})`}</Text>
              &nbsp; &nbsp;
              <Checkbox checked={isAlternateLanguageUsed} onChange={handleChange} />
            </Box>
          )}
          <Box m={{ sm: '400' }} flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
            <Heading>Roles</Heading>
            {map(
              sortBy(userAccount?.roles, (r) => r?.roleName),
              (role) => {
                return (
                  <Box m={{ sm: '300' }} key={role?.roleName}>
                    <Text size="300">{role?.roleName}</Text>
                  </Box>
                );
              }
            )}
          </Box>
          <Box m={{ sm: '400' }} flexDirection={{ sm: 'column' }} flexGrow={{ sm: '1' }}>
            <Heading>Permissions</Heading>
            {map(userAccount?.permissions, (permission) => {
              return (
                <Box m={{ sm: '300' }} key={permission?.permissionName}>
                  <Text size="300">{permission?.permissionName}</Text>
                </Box>
              );
            })}
          </Box>
        </SideSheetBodyStyled>
      </DrawerOuterStyled>
    </DrawerBackdropStyled>
  );
};

export default MyAccount;
